<template>
  <div class="mobiamex-destInput t-center">
    <div class="t-label mb-s first-header">{{ planTripText }}</div>
    <div class="header-title header-title--singapore container">
      <span class="t-sub-title header-main-color">{{ planTripTextSubText }}</span>
      <h1 class="t-title mb-s header-main-color">{{ whereToGoText }}</h1>
      <div class="header-main-color t-left d-none">{{ getStartedText }}</div>
      <slot name="powered" />
    </div>
    <div class="filter-header-section">
      <div class=" container">
        <slot name="filter-inputs" />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    planTripText: {
      type: String,
      default: 'Plan My Next Trip',
    },
    planTripTextSubText: {
      type: String,
      default: 'Explore Singapore',
    },
    whereToGoText: {
      type: String,
      default: 'Plan your Next Trip',
    },
    getStartedText: {
      type: String,
      default:
        'We help you find the best flights, places to stay & things to do based on your preferences so you can dream big for your next trip!',
    },
    travelBenefits: {
      type: String,
      default:
        'All travel benefits, including using points and discounts to flight/hotel bookings, can still be applied at the checkout step after trip planning.',
    },
  },
};
</script>

<style scoped lang="scss">
.d-none {
  display: none;
}
.mobiamex-destInput {
  border-radius: var(--discover-header-br, 20px);
  background-image: var(--discover-header-bg, url('./bg-destinput.jpg'));
  background-size: 100%;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
}

.header-title {
  display: flex;
  justify-content: center;
  align-items: center;
  &--singapore {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
    min-height: 100px;
    .t-title {
      font-size: 48px;
      font-weight: 900;
      margin-top: 15px;
    }
  }
  max-width: var(--page-container-width);
  margin: 0 auto;

  h1 {
    text-align: left;
    font-size: 48px;
    font-weight: 500;
    letter-spacing: 0;
    margin-top: 25px;
  }
  span {
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
    margin-top: 15px;
  }
  div {
    margin-top: 20px;
    font-size: 21px;
    font-weight: 400;
  }
}

.header-main-color {
  color: var(--discover-header-color);
}

.first-header {
  display: var(--discover-header-display-plan-text, block);
}

.filter-header-section {
  width: 100%;
  background: var(--page-bg);
  margin: var(--discover-header-margin-full, 115px 0px -50px 0px);
}
</style>
